export default "<!-- Overlay For Sidebars -->\r\n<div class=\"overlay\" (click)=\"closeMenu()\"></div>\r\n\r\n\r\n\r\n<router-outlet></router-outlet>";